import {
    lowerCase
} from "./helpers";
/** ------------------------ start home page ------------------------ **/

/** ------------------------ start section main ------------------------ **/

$(document).on("home:section:main", function () {
    // check if have section#main run swupMain
    if ($("section#main").length > 0) {
        console.log("main");
        swupMain();
    }
});

function swupMain() {
    // change backdrop
    // add class main
    let tl = gsap.timeline();

    // check .mil-preloader.mil-hidden is hidden, make distance 0
    tl.addLabel("main-1", 0);
    tl.addLabel("main-2", 0);
    tl.addLabel("main-3", 0);
    tl.addLabel("main-4", 1);
    tl.to(".js-main-1", {
        '--clip-path': 'rect(0 200% 100% 0%)',
        duration: 1,
    }, "main-1")

    tl.to(".js-main-2", {
        '--transform': 'translateX(0)',
        '--inner-transform': 'translateX(0)',
        duration: 2,
    }, "main-2");

    tl.to(".js-main-3", {
        '--transform': 'translateX(0)',
        '--inner-transform': 'translateX(0)',
        duration: 2,
    }, "main-3");

    tl.to(".mil-services-grid-item", {
        '--transform': 'translateY(0)',
        '--inner-transform': 'translateY(0)',
        duration: 2,
        stagger: 0.5,
        onComplete: function () {
            $("#main").addClass("active");
        }
    }, "main-4");

    // start lottie animation
    let lottieAnimation = lottie.loadAnimation({
        container: document.getElementById('lottie-animation'),
        path: document.getElementById('lottie-animation').dataset.path,
        renderer: 'svg',
        loop: false,
        autoplay: false,
    });



    // media query max-width 991.98px play
    if (window.matchMedia("(max-width: 991.98px)").matches) {
        lottieAnimation.play();
    } else {
        $("#lottie-animation").mouseenter(function () {
            lottieAnimation.play();
        });

        $("#lottie-animation").mouseleave(function () {
            lottieAnimation.stop();
        });
    }
}

/** ------------------------ end section main ------------------------ **/

/** ------------------------ start section performance marketing ------------------------ **/
$(document).on("home:section:performance-marketing", function () {
    // check if have section#performance-marketing run swupPerformanceMarketing
    if ($("section#performance-marketing").length > 0) {
        swupPerformanceMarketing();
    }
});

function swupPerformanceMarketing() {
    // each swiper-container
    $(".swiper-performance-marketing-container").each(function () {
        new Swiper($(this).find(".swiper")[0], {
            slidesPerView: 1,
            spaceBetween: 60,
            navigation: {
                nextEl: $(this).find('.mil-next')[0],
                prevEl: $(this).find('.mil-prev')[0],
            },
            breakpoints: {
                0: {
                    slidesPerView: 1.1,
                    spaceBetween: 10,
                },
                992: {
                    slidesPerView: 1,
                    spaceBetween: 60,
                }
            },
        });
    });
}
/** ------------------------ end section performance marketing ------------------------ **/

/** ------------------------ start section commercial video ------------------------ **/
$(document).on("home:section:commercial-video", function () {
    // check if have section#commercial-video run swupCommercialVideo
    if ($("section#commercial-video").length > 0) {
        swupCommercialVideo();
    }
});

function swupCommercialVideo() {
    // swiper-slides-active slide play video
    ScrollTrigger.create({
        trigger: "#commercial-video",
        start: "top center",
        end: "bottom center",
        onEnter: function () {
            // swiper-slides-active slide play video
            const video = $(".swiper-video-container .swiper-slide-active video");

            if (video.length > 0) {
                video[0].play();
            }
        },
        onEnterBack: function () {
            // swiper-slides-active slide play video
            const video = $(".swiper-video-container .swiper-slide-active video");

            if (video.length > 0) {
                video[0].play();
            }
        },
        onLeave: function () {
            // swiper-slides-active slide pause video
            const video = $(".swiper-video-container .swiper-slide-active video");

            if (video.length > 0) {
                video[0].pause();
            }
        },
        onLeaveBack: function () {
            // swiper-slides-active slide pause video
            const video = $(".swiper-video-container .swiper-slide-active video");

            if (video.length > 0) {
                video[0].pause();
            }
        }
    });

    // init all video add playbackRate 5
    // $(".swiper-video-container video").each(function() {
    //     this.playbackRate = 5;
    // });

    // start commercial video
    $(".swiper-video-container").each(function () {
        const swiper = new Swiper($(this).find(".swiper")[0], {
            slidesPerView: 1,
            spaceBetween: 60,
            // disabled touch event
            allowTouchMove: true,
            pagination: {
                el: $(this).find('.swiper-c-pagination')[0],
                clickable: true,
            },
            breakpoints: {
                0: {
                    slidesPerView: 1.1,
                    spaceBetween: 10,
                    pagination: false,
                },
                992: {
                    slidesPerView: 1,
                    spaceBetween: 60,
                }
            },
        });

        // init video timeline is 1
        $(".swiper-video-container video").each(function () {
            this.currentTime = 1;
        });

        // slide change transaction start will pause video
        swiper.on("slideChangeTransitionStart", function () {
            // all video pause
            $(".swiper-video-container video").each(function () {
                this.pause();
            });
        });

        // slide change end will play video
        swiper.on("slideChangeTransitionEnd", function () {
            const video = $(swiper.slides[swiper.activeIndex]).find("video")[0];
            video.play();
        });

        // play video finish will go next slide
        $(".swiper-video-container video").on("ended", function () {
            const swiper = $(this).closest(".swiper")[0].swiper;
            swiper.slideNext();

            // js-play button change refresh icon
            $(this).closest(".swiper-video-container").find(".js-play").html(
                '<i class="fas fa-refresh"></i>');
        });

        // last video play end will go first slide when touch move
        swiper.on("touchEnd", function () {
            if (swiper.activeIndex === swiper.slides.length - 1) {
                // when last video is end
                if (swiper.slides[swiper.activeIndex].querySelector("video")
                    .ended) {
                    // reset video play time
                    $(".swiper-video-container video").each(function () {
                        this.currentTime = 1;
                    });
                    swiper.slideTo(0);
                }
            }
        });

        if (window.matchMedia("(min-width: 992px)").matches) {
            // click .swiper-commercial-item pause or play video
            $(this).find(".swiper-commercial-item").on("click", function () {
                // check parent swiper is active, is not active will return
                if (!$(this).closest(".swiper-slide").hasClass("swiper-slide-active")) {
                    return;
                }
                const video = $(this).find("video")[0];
                if (video.paused) {
                    video.play();
                } else {
                    video.pause();
                }
            });
        }

        // add class c-progress at swiper-pagination-bullet when init
        $(this).find(".swiper-c-pagination .swiper-pagination-bullet").each(function () {
            $(this).addClass("c-progress");
        });

        // video get timeline set progress bar
        $(".swiper-video-container video").on("timeupdate", function () {
            const video = this;
            const progress = video.currentTime / video.duration * 100;
            // add class progress bar at swiper-pagination-bullet-active
            $(video).closest(".swiper-video-container").find(
                ".swiper-c-pagination .swiper-pagination-bullet-active").css(
                "--pagination-progress-bar", progress + "%");
        });

        // toggle play button play or pause video
        $(this).find(".js-play").on("click", function () {
            // check swiper is end go to first slide
            if (swiper.activeIndex === swiper.slides.length - 1 && swiper.slides[
                    swiper
                    .activeIndex].querySelector(
                    "video").ended) {
                // when last video is end
                if (swiper.slides[swiper.activeIndex].querySelector("video")
                    .ended) {
                    // reset video play time
                    $(".swiper-video-container video").each(function () {
                        this.currentTime = 1;
                    });
                    swiper.slideTo(0);

                    // play video
                    const video = $(this).closest(".swiper-video-container").find(
                        ".swiper-slide-active video");

                    if (video.length > 0) {
                        video[0].play();
                    }
                }
            } else {
                const video = $(this).closest(".swiper-video-container").find(
                    ".swiper-slide-active video");

                if (video.length > 0) {
                    if (video[0].paused) {
                        video[0].play();
                    } else {
                        video[0].pause();
                    }
                }
            }

        });

        // on video play or pause change icon
        $(".swiper-video-container video").on("play pause", function () {
            const video = this;
            const btnPlay = $(video).closest(".swiper-video-container").find(
                ".js-play");
            if (video.paused) {
                btnPlay.html('<i class="fas fa-play"></i>');
            } else {
                btnPlay.html('<i class="fas fa-pause"></i>');
            }
        });

    });
    // end commercial video
}
/** ------------------------ end section commercial video ------------------------ **/

/** ------------------------ start section short video ------------------------ **/
$(document).on("home:section:short-video", function () {
    // check if have section#short-video run swupShortVideo
    if ($("section#short-video").length > 0) {
        swupHomeShortVideo();
    }
});

function swupHomeShortVideo() {
    // start short video
    setTimeout(function () {
        ScrollTrigger.refresh();
    }, 1000);
    $(".swiper-short-video-container").each(function () {
        const swiperShortVideo = new Swiper($(this).find(".swiper")[0], {
            slidesPerView: 4,
            spaceBetween: 20,
            loop: true,
            // disabled touch event
            allowTouchMove: true,
            loopPreventsSliding: false,
            breakpoints: {
                0: {
                    slidesPerView: 1.1,
                    spaceBetween: 10,
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
                992: {
                    slidesPerView: 4,
                    spaceBetween: 20,
                }
            },
            pagination: {
                el: $(this).find('.swiper-c-pagination')[0],
                clickable: true,
            },
        });

        // slideNext custom event
        $(this).on("slide-next", function () {
            swiperShortVideo.slideNext();
        });

        // slidePrev custom event
        $(this).on("slide-prev", function () {
            swiperShortVideo.slidePrev();
        });

        // slide change transaction start will pause video
        swiperShortVideo.on("slideChangeTransitionStart", function () {
            // all video pause
            $(".swiper-short-video-container video").each(function () {
                this.pause();
            });
        });

        // slide change end will play video
        swiperShortVideo.on("slideChangeTransitionEnd", function () {
            // check glightbox is open will return
            const video = $(swiperShortVideo.slides[swiperShortVideo.activeIndex])
                .find("video");

            if (video.length > 0) {
                video[0].play();
            }
        });

        // play video finish will go next slide
        $(".swiper-short-video-container video").on("ended", function () {
            const swiper = $(this).closest(".swiper")[0].swiper;
            swiper.slideNext();
        });

        // add class c-progress at swiper-pagination-bullet when init
        $(this).find(".swiper-c-pagination .swiper-pagination-bullet").each(function () {
            $(this).addClass("c-progress");
        });

        // video get timeline set progress bar
        $(".swiper-short-video-container video").on("timeupdate", function () {
            const video = this;
            const progress = video.currentTime / video.duration * 100;
            // add class progress bar at swiper-pagination-bullet-active
            $(video).closest(".swiper-short-video-container").find(
                ".swiper-c-pagination .swiper-pagination-bullet-active").css(
                "--pagination-progress-bar", progress + "%");

            // set video play time is 1 when video is end
            if (video.ended) {
                video.currentTime = 1;
            }
        });

        if (window.matchMedia("(min-width: 992px)").matches) {
            // hover pause video
            $(this).find(".swiper-short-video-item").on("mouseenter", function () {
                // check parent swiper is active, is not active will return
                const video = $(this).find("video")[0];
                if (!$(this).closest(".swiper-slide").hasClass("swiper-slide-active")) {
                    return;
                }
                video.pause();
            });

            // unhover play video
            $(this).find(".swiper-short-video-item").on("mouseleave", function () {
                // check parent swiper is active, is not active will return and check glightbox is open
                const video = $(this).find("video");

                if (video.length > 0) {
                    if (!$(this).closest(".swiper-slide").hasClass("swiper-slide-active")) {
                        video[0].pause();
                        return;
                    }

                    video[0].play();
                }
            });
        }

        // toggle play button play or pause video
        $(this).find(".js-play").on("click", function () {
            const video = $(this).closest(
                    ".swiper-short-video-container")
                .find(".swiper-slide-active video");

            if (video.length > 0) {
                if (video[0].paused) {
                    video[0].play();
                } else {
                    video[0].pause();
                }
            }
        });

        // on video play or pause change icon
        $(".swiper-short-video-container video").on("play pause", function () {
            const video = this;
            const btnPlay = $(video).closest(".swiper-short-video-container").find(
                ".js-play");
            if (video.paused) {
                btnPlay.html('<i class="fas fa-play"></i>');
            } else {
                btnPlay.html('<i class="fas fa-pause"></i>');
            }
        });
    });
    // end short video

    runAnimation();

    function runAnimation() {
        // start scroll animation for DOM element .swiper-short-video-item dynamic
        const item = document.querySelectorAll('.swiper-short-video-item');

        if (item.length === 0) {
            return;
        }

        // media query adjust start and end animation
        let start = "top 80%";
        let end = "bottom 80%";

        if (window.matchMedia("(max-width: 991.98px)").matches) {
            start = "top 90%";
            end = "bottom 90%";
        }

        let tl = null;

        // each item step by step animation up and delay
        item.forEach((el, index) => {
            tl = gsap.timeline({
                    scrollTrigger: {
                        trigger: el.parentElement,
                        start: start,
                        end: end,
                        toggleActions: 'play none none reverse',
                    },
                })
                .fromTo(el, {
                    translateY: 500,
                    opacity: 0,
                    ease: 'linear',
                }, {
                    translateY: 0,
                    opacity: 1,
                    delay: 0.1 * index,
                    duration: 1,
                });
        });

        tl.add("after-show", ">");

        item.forEach((el, index) => {
            tl.fromTo(el, {
                '--inner-transform': 'translateY(0%)',
                '--item-pointer-events': 'none',
                ease: 'linear',
            }, {
                '--inner-transform': 'translateY(100%)',
                '--item-pointer-events': 'auto',
                duration: 0.2,
            }, "after-show");
        });
        const swiperSection = document.querySelector("#swiper-progress-short-video");

        tl.fromTo(swiperSection, {
            '--before-translate-y': '300%',
            '--before-opacity': 0,
            ease: 'linear',
        }, {
            '--before-translate-y': '-50%',
            '--before-opacity': 1,
            duration: 0.02,
        }, "progress-0-short-video");

        tl.add("progress-1-short-video", ">+=0.5");

        tl.fromTo(swiperSection, {
            // custom css properties root
            '--before-width': '70px',
            '--before-border-radius': '50px',
            // delay opacity
            // ease: 'cubic-bezier(0.215, 0.61, 0.355, 1)',
            ease: 'linear',
        }, {
            '--before-width': '100%',
            '--before-border-radius': '50px',
            duration: 0.02,
        }, "progress-1-short-video");

        tl.add("progress-2-short-video", ">+=0.5");

        tl.fromTo(swiperSection, {
            '--before-opacity': 1,
            ease: 'linear',
        }, {
            '--before-opacity': 0,
            duration: 0.2,
        }, "progress-2-short-video");

        tl.add("progress-3-short-video", ">-=0.5");

        tl.fromTo(swiperSection, {

            '--item-left-transform': 'translateX(500px)',
            '--item-right-transform': 'translateX(-500px)',
            '--item-pointer-events': 'none',
            ease: 'cubic-bezier(.15,.65,.47,.04)',
        }, {

            '--item-left-transform': 'translateX(0)',
            '--item-right-transform': 'translateX(0)',
            '--item-pointer-events': 'auto',
            duration: 0.5,
        }, "progress-3-short-video");

        tl.add("progress-4-short-video", ">-=0.2");

        tl.fromTo(swiperSection, {
            '--item-opacity': 0,
            ease: 'linear',
        }, {
            '--item-opacity': 1,
            duration: 0.5,
        }, "progress-4-short-video");

        // scroll to #section.section-short-video will play swiper-slides-active video when visible in viewport
        ScrollTrigger.create({
            trigger: "#short-video",
            start: "top center",
            end: "bottom center",
            onEnter: function () {
                // swiper-slides-active slide play video
                const video = $(".swiper-short-video-container .swiper-slide-active video");

                if (video.length > 0) {
                    video[0].play();
                }
            },
            onEnterBack: function () {
                // swiper-slides-active slide play video
                const video = $(".swiper-short-video-container .swiper-slide-active video");

                if (video.length > 0) {
                    video[0].play();
                }
            },
            onLeave: function () {
                // swiper-slides-active slide pause video
                const video = $(".swiper-short-video-container .swiper-slide-active video");

                if (video.length > 0) {
                    video[0].pause();
                }
            },
            onLeaveBack: function () {
                // swiper-slides-active slide pause video
                const video = $(".swiper-short-video-container .swiper-slide-active video");

                if (video.length > 0) {
                    video[0].pause();
                }
            }
        });
    }
}
/** ------------------------ end section short video ------------------------ **/

/** ------------------------ start section product branding ------------------------ **/
$(document).on('home:section:product-branding', function () {
    // check if have section#product-branding run swupProductBranding
    if ($("section#product-branding").length > 0) {
        swupProductBranding();
    }
});

function swupProductBranding() {
    // each swiper-container
    $(".swiper-product-branding-container").each(function () {
        new Swiper($(this).find(".swiper")[0], {
            slidesPerView: 3,
            spaceBetween: 30,
            navigation: {
                nextEl: $(this).find('.mil-next')[0],
                prevEl: $(this).find('.mil-prev')[0],
            },
            breakpoints: {
                0: {
                    slidesPerView: 1.1,
                    spaceBetween: 10,
                    navigation: false,
                },
                // lg
                992: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                },
            },
        });
    });

    const item = document.querySelectorAll('.swiper-item-animation');

    let delay = 0;

    // media query adjust start and end animation
    let start = "top 80%";
    let end = "bottom 80%";

    if (window.matchMedia("(max-width: 991.98px)").matches) {
        start = "top 90%";
        end = "bottom 90%";
    }

    let tl = null;

    item.forEach((el, index) => {
        delay = index * 0.1;

        // from left to origin
        tl = gsap.timeline({
            scrollTrigger: {
                trigger: el,
                start: start,
                end: end,
                toggleActions: 'play none none reverse',
            },
        }).fromTo(el, {
            x: -200,
            delay: delay,
            opacity: 0,
        }, {
            x: 0,
            opacity: 1,
            delay: delay,
            duration: 1,
        });
    });

    const swiperSection = document.querySelector("#swiper-progress-product-branding");

    tl.fromTo(swiperSection, {
        '--before-translate-y': '300%',
        '--before-opacity': 0,
        ease: 'linear',
    }, {
        '--before-translate-y': '-50%',
        '--before-opacity': 1,
        duration: 0.02,
    }, "progress-0-product-branding");

    tl.add("progress-1-product-branding", ">+=0.5");

    tl.fromTo(swiperSection, {
        // custom css properties root
        '--before-width': '70px',
        '--before-border-radius': '50px',
        // delay opacity
        // ease: 'cubic-bezier(0.215, 0.61, 0.355, 1)',
        ease: 'linear',
    }, {
        '--before-width': '100%',
        '--before-border-radius': '50px',
        duration: 0.02,
    }, "progress-1-product-branding");

    tl.add("progress-2-product-branding", ">+=0.5");

    tl.fromTo(swiperSection, {
        '--before-opacity': 1,
        ease: 'linear',
    }, {
        '--before-opacity': 0,
        duration: 0.2,
    }, "progress-2-product-branding");

    tl.add("progress-3-product-branding", ">-=0.5");

    tl.fromTo(swiperSection, {

        '--item-left-transform': 'translateX(500px)',
        '--item-right-transform': 'translateX(-500px)',
        '--item-pointer-events': 'none',
        ease: 'cubic-bezier(.15,.65,.47,.04)',
    }, {

        '--item-left-transform': 'translateX(0)',
        '--item-right-transform': 'translateX(0)',
        '--item-pointer-events': 'auto',
        duration: 0.5,
    }, "progress-3-product-branding");

    tl.add("progress-4-product-branding", ">-=0.2");

    tl.fromTo(swiperSection, {
        '--item-opacity': 0,
        ease: 'linear',
    }, {
        '--item-opacity': 1,
        duration: 0.5,
    }, "progress-4-product-branding");
}
/** ------------------------ end section product branding ------------------------ **/

/** ------------------------ start section meet our client ------------------------ **/
$(document).on('home:section:meet-our-client', function () {
    // check if have section#meet-our-client run swupMeetOurClient
    if ($("section#meet-our-client").length > 0) {
        swupMeetOurClient();
    }
});

function swupMeetOurClient() {
    const item = document.querySelectorAll('.client-img');

    // media query adjust start and end animation
    let start = "top 80%";
    let end = "bottom 80%";

    if (window.matchMedia("(max-width: 991.98px)").matches) {
        start = "top 90%";
        end = "bottom 90%";

        item.forEach((el, index) => {
            gsap.fromTo(el, {
                y: 100,
                opacity: 0
            }, {
                y: 0,
                opacity: 1,
                duration: 0.2,
                scrollTrigger: {
                    trigger: el,
                    start: start,
                    end: end,
                    toggleActions: 'play none none reverse',
                }
            });
        });
    } else {
        // 1 to 4 item from left to origin
        item.forEach((el, index) => {
            if (index < 5) {
                gsap.fromTo(el, {
                    x: -100,
                    opacity: 0
                }, {
                    x: 0,
                    opacity: 1,
                    duration: 0.5,
                    scrollTrigger: {
                        trigger: el,
                        start: start,
                        end: end,
                        toggleActions: 'play none none reverse',
                    }
                });
            } else {
                gsap.fromTo(el, {
                    x: 100,
                    opacity: 0
                }, {
                    x: 0,
                    opacity: 1,
                    duration: 0.5,
                    scrollTrigger: {
                        trigger: el,
                        start: start,
                        end: end,
                        toggleActions: 'play none none reverse',
                    }
                });
            }
        });
    }
}

/** ------------------------ end section meet our client ------------------------ **/

/** ------------------------ end home page ------------------------ **/

/** ------------------------ start component ------------------------ **/

swiperMeetOurClient();

function swiperMeetOurClient() {
    const swiperGrid = new Swiper('.swiper-grid-meet-client', {
        grid: {
            rows: 2,
            fill: 'row',
        },
        slidesPerView: 5,
        spaceBetween: 50,
        autoplay: true,
        // next and prev button
        navigation: {
            nextEl: '.mil-shared-next',
            prevEl: '.mil-shared-prev',
        },
        breakpoints: {
            0: {
                grid: {
                    rows: 1,
                },
                slidesPerView: 1,
                spaceBetween: 10,
            },
            992: {
                grid: {
                    rows: 2,
                    fill: 'row',
                },
                slidesPerView: 5,
                spaceBetween: 50,
            },
        },
    });
}


$(document).on("swup:content:replace", function () {
    // trigger custom event
    swiperMeetOurClient();
});
/** ------------------------ end component ------------------------ **/
